import { render, staticRenderFns } from "./itemenriquecido-form.vue?vue&type=template&id=6dbc2f75&scoped=true"
import script from "./itemenriquecido-form.vue?vue&type=script&lang=js"
export * from "./itemenriquecido-form.vue?vue&type=script&lang=js"
import style0 from "./itemenriquecido-form.vue?vue&type=style&index=0&id=6dbc2f75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc2f75",
  null
  
)

export default component.exports